import { render, staticRenderFns } from "./token-calls.vue?vue&type=template&id=11d1a0bb&"
import script from "./token-calls.vue?vue&type=script&lang=js&"
export * from "./token-calls.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports